import { Component, OnInit, Inject, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountingModel } from './accountingModel.model';
import { AccountingModelService } from './accountingModel.service';
import {
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';
import { CoreComponent } from '../../../core/header/core.component';
import { DummyComponent } from '../../../shared/dummy.component';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountingModelListComponent } from './accountingModel-list.component';

@Component({
    selector: 'convfact-accountingModel',
    templateUrl: './accountingModel.component.html',
    styleUrls: ['./accountingModel.component.css'],
    standalone: false
})
export class AccountingModelComponent implements OnInit {
  accountingModel = new AccountingModel();
  errors: Record<string, unknown> = {};
  ready = false;

  public readonly data = inject(MAT_DIALOG_DATA) as { uid: string };
  public readonly dialogRef = inject(MatDialogRef<AccountingModelListComponent>);
  private readonly accountingModelService = inject(AccountingModelService);
  private readonly route = inject(ActivatedRoute);
  public readonly snackBar = inject(MatSnackBar);
  private readonly core = inject(CoreComponent);
  private readonly dummy = inject(DummyComponent);

  get uid(): string {
    return this.data?.uid;
  }

  submit(): void {}

  async ngOnInit(): Promise<void> {
    if (this.uid != null) {
      this.accountingModel = await this.accountingModelService.loadData(this.uid);
      this.accountingModel.type = this.accountingModel.type.toLowerCase();
      this.ready = true;
    } else {
      this.ready = true;
    }
  }

  async saveData(accountingModel: AccountingModel): Promise<void> {
    accountingModel.activityUid = this.core.activitySelected;

    if (accountingModel.uid === undefined) {
      try {
        this.accountingModel = await this.accountingModelService.addData(accountingModel);
        this.core.refresh();
        this.returnToIndex();
        this.dialogRef.close();
      } catch (error: any) {
      }
    } else {
      this.accountingModel = await this.accountingModelService.editData(
        accountingModel.uid,
        accountingModel
      );
      this.displayInfo('Cuenta contable modificada con éxito');
      this.core.refresh();
      this.returnToIndex();
      this.dialogRef.close();
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  returnToIndex(): void {
    this.dummy.redirectTo('/account/accountingmodel');
  }
}